import React from 'react'
import { BOOKMAKER_LOGOS } from '../config/bookmakers'
import { playerImageUrlFromSelection as getPlayerImageUrl } from '../config/playerImages'

const formatDateTime = (ts) =>
  new Date(ts + 'Z').toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true,
  })

const parseSelection = (sel) => {
  if (!sel) return { name: sel, dir: null, line: null }
  const m = sel.match(/^(.+?)\s+(over|under)\s+(.+)$/i)
  if (!m) return { name: sel, dir: null, line: null }
  return { name: m[1], dir: m[2].toLowerCase(), line: m[3] }
}

export default function PickEmHiddenModal({ isOpen, hiddenBets, onUnhide, onUnhideAll, onClose }) {
  if (!isOpen) return null

  const entries = Object.entries(hiddenBets)

  return (
    <>
      <div className="bc-overlay" onClick={onClose} />
      <div className="phm-modal">

        <div className="phm-header">
          <div className="phm-header-left">
            <span className="phm-title">Hidden Bets</span>
            {entries.length > 0 && <span className="phm-count">{entries.length}</span>}
          </div>
          <div className="phm-header-right">
            {entries.length > 0 && (
              <button className="bc-btn phm-unhide-all" onClick={onUnhideAll}>
                Unhide All
              </button>
            )}
            <button className="bc-panel-close" onClick={onClose}>×</button>
          </div>
        </div>

        <div className="phm-body">
          {entries.length === 0 ? (
            <div className="phm-empty">No hidden bets</div>
          ) : (
            entries.map(([key, bet]) => {
              const { name, dir, line } = parseSelection(bet.selection || bet.player_name)
              const ev = bet.ev
              const evClass = ev >= 10 ? 'bc-ev-high' : ev >= 5 ? 'bc-ev-mid' : 'bc-ev-low'
              return (
                <div key={key} className="phm-row">
                  <div className="phm-row-inner">

                    <div className="phm-avatar-wrap">
                      <img
                        src={getPlayerImageUrl(bet.selection || bet.player_name, bet.sport)}
                        alt=""
                        className="phm-avatar"
                        onLoad={e  => { e.target.style.opacity = '1'; e.target.parentNode.classList.remove('bc-avatar-missing') }}
                        onError={e => { e.target.style.opacity = '0'; e.target.parentNode.classList.add('bc-avatar-missing') }}
                      />
                    </div>

                    <div className="phm-row-info">
                      <span className="phm-player">{name}</span>
                      {dir && (
                        <span className={`bc-sel-badge ${dir}`}>
                          <span className="bc-sel-badge-dir">{dir.charAt(0).toUpperCase() + dir.slice(1)}</span>
                          <span className="bc-sel-badge-num">{line}</span>
                        </span>
                      )}
                      <div className="phm-sub">{bet.match}</div>
                      <div className="phm-sub">{formatDateTime(bet.commence_time)}</div>
                    </div>

                    <div className="phm-row-actions">
                      <div className="bc-book-cell">
                        <img src={BOOKMAKER_LOGOS['Dabble']} alt="Dabble" className="bc-book-logo" title="Dabble" />
                      </div>
                      {ev != null && (
                        <span className={`bc-ev-badge ${evClass}`}>
                          {ev > 0 ? '+' : ''}{ev.toFixed(2)}%
                        </span>
                      )}
                      <button className="phm-unhide-btn" onClick={() => onUnhide(key)} title="Unhide">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                          <circle cx="12" cy="12" r="3"/>
                        </svg>
                      </button>
                    </div>

                  </div>
                </div>
              )
            })
          )}
        </div>

      </div>
    </>
  )
}
